import { createAsyncThunk } from '@reduxjs/toolkit';
import authModel from 'store/models/auth';
import { TRegisterRequest, TSmsSendRequest } from '../loginSchema';
import { InitDataType } from '@tma.js/sdk-react';
import type { WebAppData } from 'shared/helpers/max/maxBridge';
import { webLoginActions } from 'pages/webLogin/store/store';

//GET
export const fetchLogin = createAsyncThunk(
  'login/fetchLogin',
  async (
    data: {
      initDataRaw: string;
      initData?: InitDataType;
      poll?: boolean;
      own_respondents_link_hash?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const response: {
        data: {
          data: { token: string; own_respondent_hash_accepted: boolean | null };
        };
      } = await authModel.postLogin({
        init_data: data.initDataRaw,
        poll: data.poll,
        own_respondents_link_hash: data?.own_respondents_link_hash,
      });
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchLoginMax = createAsyncThunk(
  'login/fetchLoginMax',
  async (
    data: {
      initDataRaw: string;
      poll?: boolean;
      own_respondents_link_hash?: string;
    },
    { rejectWithValue },
  ) => {
    try {
      const response: {
        data: {
          data: { token: string; own_respondent_hash_accepted: boolean | null };
        };
      } = await authModel.postLoginMax({
        init_data: data.initDataRaw,
        poll: data.poll,
        own_respondents_link_hash: data?.own_respondents_link_hash,
      });
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchLoginWeb = createAsyncThunk(
  'login/fetchLoginWeb',
  async (
    data: {
      phone: string;
      code: string;
      own_respondents_link_hash?: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const response: {
        data: {
          data: { token: string; own_respondent_hash_accepted: boolean | null };
        };
      } = await authModel.postLoginWeb(data);
      return response;
    } catch (e) {
      if (e?.errors?.phone?.includes('Пользователь не прошел регистрацию')) {
        dispatch(webLoginActions.setFormType('registration'));
      }
      return rejectWithValue(e);
    }
  },
);

export const fetchRegister = createAsyncThunk(
  'login/fetchRegister',
  async (
    data: TRegisterRequest & { initData?: InitDataType },
    { rejectWithValue },
  ) => {
    try {
      const { initData, ...rest } = data;
      const response: { data: { data: { token: string } } } =
        await authModel.postRegister(rest);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchRegisterMax = createAsyncThunk(
  'login/fetchRegisterMax',
  async (
    data: TRegisterRequest & { initData?: InitDataType | WebAppData },
    { rejectWithValue },
  ) => {
    try {
      const { initData, ...rest } = data;
      const response: { data: { data: { token: string } } } =
        await authModel.postRegisterMax(rest);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchRegisterWeb = createAsyncThunk(
  'login/fetchRegisterWeb',
  async (data: TRegisterRequest, { rejectWithValue }) => {
    try {
      const { ...rest } = data;
      const response: { data: { data: { token: string } } } =
        await authModel.postRegisterWeb(rest);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchSendSms = createAsyncThunk(
  'login/fetchSendSms',
  async (data: TSmsSendRequest, { rejectWithValue }) => {
    try {
      const response: { data: { data: { message: string } } } =
        await authModel.postSmsSend(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);

      //errors: {time: [41]} //пример ошибки
    }
  },
);
